export default ({ displayName }) => displayName;
